import { render, staticRenderFns } from "./DialogAntrag.vue?vue&type=template&id=371452d2&scoped=true"
import script from "./DialogAntrag.vue?vue&type=script&lang=ts"
export * from "./DialogAntrag.vue?vue&type=script&lang=ts"
import style0 from "./DialogAntrag.vue?vue&type=style&index=0&id=371452d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371452d2",
  null
  
)

export default component.exports